import { isEqual } from 'lodash'
import { TFilters } from 'apps/marketplace/components/PageList'
import { cleanObject } from '../getCleanObject'
import { TCurrentFiltersWithPagination } from './pageChangeHandler'

interface IFilterChangeHandlerArgs<Filters> {
  currentFilters: TCurrentFiltersWithPagination<Filters>
  setCurrentFilters: (filters: TCurrentFiltersWithPagination<Filters>) => void
  itemsPerPage: number
}

/**
 * When filters are changed, this handles updating query variables and resets page
 * so that the first page of results are fetched.
 */
export const filterChangeHandler = <Filters>({
  currentFilters,
  itemsPerPage,
  setCurrentFilters,
}: IFilterChangeHandlerArgs<Filters>) => (props: Partial<TFilters<Filters>>) => {
  const cleanedProps = cleanObject({
    ...props,
    before: null,
    after: null,
    first: itemsPerPage,
    last: undefined,
  })

  if (isEqual(cleanedProps, currentFilters)) return

  setCurrentFilters(cleanedProps)
}
